// PartCPage4.jsx - Part C Page 4 for HPC Report (Pixel-perfect redesign - Stage 1 Learner Reflection)
import React from 'react';

const PartCPage4 = ({ data }) => {
  const studentData = data || {};

  const calculateTotal = (category) => {
    if (!category) return 0;
    let total = 0;
    if (category.item_1) total++;
    if (category.item_2) total++;
    if (category.item_3) total++;
    return total;
  };

  const renderCategory = (categoryName, title, items) => {
    const category = studentData[categoryName] || {};

    return (
      <div style={{ marginBottom: '12px' }}>
        <div style={{
          backgroundColor: '#4A90A4',
          color: 'white',
          padding: '6px 12px',
          fontWeight: 'bold',
          fontSize: '11px',
          marginBottom: '0'
        }}>
          {title}
        </div>
        <div style={{
          fontSize: '10px',
          padding: '10px 12px',
          backgroundColor: '#B3D9E8',
          minHeight: '80px'
        }}>
          {items.map((item, index) => (
            <div key={index} style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '5px' }}>
              <div style={{
                width: '16px',
                height: '16px',
                border: '2px solid #333',
                marginRight: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                marginTop: '1px',
                backgroundColor: 'white'
              }}>
                {category[`item_${index + 1}`] && '✓'}
              </div>
              <span style={{ lineHeight: '1.4' }}>{item}</span>
            </div>
          ))}

          <div style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            marginTop: '12px',
            paddingTop: '8px'
          }}>
            <span style={{ marginRight: '10px', fontWeight: 'bold', fontSize: '10px' }}>Total number of (✓):</span>
            <div style={{
              width: '35px',
              height: '35px',
              border: '3px solid #4A90A4',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 'bold',
              fontSize: '14px',
              backgroundColor: 'white'
            }}>
              {calculateTotal(category)}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="report-page" style={{
      width: '210mm',
      minHeight: '297mm',
      padding: '20mm',
      backgroundColor: 'white',
      boxSizing: 'border-box',
      fontFamily: 'Arial, sans-serif',
      position: 'relative'
    }}>
      {/* Decorative top-right corner */}
      <div style={{
        position: 'absolute',
        top: 0,
        right: 0,
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '0 80px 80px 0',
        borderColor: 'transparent #F4824C transparent transparent'
      }} />

      {/* Stage 1 Header - Orange */}
      <div style={{
        fontSize: '14px',
        fontWeight: 'bold',
        marginBottom: '10px',
        textAlign: 'center',
        backgroundColor: '#F4824C',
        color: 'white',
        padding: '8px'
      }}>
        Stage 1
      </div>

      {/* Learner Reflection Label - Blue */}
      <div style={{
        fontSize: '12px',
        fontWeight: 'bold',
        marginBottom: '12px',
        backgroundColor: '#4A90A4',
        color: 'white',
        padding: '6px 12px',
        display: 'inline-block'
      }}>
        Learner Reflection
      </div>

      {/* Instructions */}
      <div style={{
        fontSize: '10px',
        marginBottom: '15px',
        padding: '0',
        fontWeight: 'bold',
        lineHeight: '1.5'
      }}>
        Tick (✓) all statements that apply.
      </div>

      {/* Awareness Category */}
      {renderCategory('awareness', 'Awareness', [
        'I understood the purpose of the research project.',
        'I was able to draft a questionnaire that fits the purpose of the research project.',
        'I was able to find out things I did not know that would help me complete the research project.'
      ])}

      {/* Sensitivity Category */}
      {renderCategory('sensitivity', 'Sensitivity', [
        'I understood the larger social purpose of the research project.',
        'I used my knowledge of social relationships to choose the respondents.',
        'I considered people\'s possible emotional reactions and needs when drafting the questionnaire.'
      ])}

      {/* Creativity Category */}
      {renderCategory('creativity', 'Creativity', [
        'I was able to consider different possible groups of respondents to use for my data.',
        'I considered various ways to motivate the respondents to provide data.',
        'I was able to consider different methods of collecting data.'
      ])}

      {/* Two Boxes Side by Side with Arrow */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginBottom: '15px', position: 'relative' }}>
        <div>
          <div style={{
            backgroundColor: '#4A90A4',
            color: 'white',
            padding: '8px 12px',
            fontWeight: 'bold',
            fontSize: '11px',
            marginBottom: '0',
            textAlign: 'center',
            lineHeight: '1.3'
          }}>
            What problems did I face in Stage 1?
          </div>
          <div style={{
            padding: '10px 12px',
            fontSize: '10px',
            minHeight: '120px',
            backgroundColor: '#B3D9E8',
            lineHeight: '1.4'
          }}>
            {studentData.problems_faced || ''}
          </div>
        </div>

        <div>
          <div style={{
            backgroundColor: '#4A90A4',
            color: 'white',
            padding: '8px 12px',
            fontWeight: 'bold',
            fontSize: '11px',
            marginBottom: '0',
            textAlign: 'center',
            lineHeight: '1.3'
          }}>
            How did I solve them? What help do I still need?
          </div>
          <div style={{
            padding: '10px 12px',
            fontSize: '10px',
            minHeight: '120px',
            backgroundColor: '#B3D9E8',
            lineHeight: '1.4'
          }}>
            {studentData.how_solved || ''}
          </div>
        </div>

        {/* Arrow between boxes */}
        <div style={{
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
          fontSize: '28px',
          color: '#4A90A4',
          fontWeight: 'bold',
          zIndex: 1,
          backgroundColor: 'white',
          padding: '0 5px'
        }}>
          ⇒
        </div>
      </div>

      {/* Page Number */}
      <div style={{
        position: 'absolute',
        bottom: '15mm',
        left: '50%',
        transform: 'translateX(-50%)',
        fontSize: '11px',
        color: '#666',
        fontWeight: 'bold'
      }}>
        22
      </div>

      {/* Bottom corners */}
      <div style={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '60px 0 0 60px',
        borderColor: 'transparent transparent transparent #F4824C'
      }} />
      <div style={{
        position: 'absolute',
        bottom: 0,
        right: 0,
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '60px 60px 0 0',
        borderColor: 'transparent #F4824C transparent transparent',
        opacity: 0.3
      }} />
    </div>
  );
};

export default PartCPage4;
